// @flow
import { Text } from 'rebass';

export default Text;
